"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _smartHeader = require("./smartHeader");

var _smartHeader2 = _interopRequireDefault(_smartHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _smartHeader2.default;